import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=a959af9e&scoped=true"
import script from "./projectDetails.vue?vue&type=script&lang=js"
export * from "./projectDetails.vue?vue&type=script&lang=js"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=a959af9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a959af9e",
  null
  
)

export default component.exports